<template>
    <div v-if="isClientPortalAppEnabled">
        <label class="global-label">{{ title }}</label>
        <v-checkbox
            dense
            :input-value="Boolean(formData.value)"
            :label="$t('Access enabled')"
            class="mt-1 mb-2"
            hide-details
            @change="accessChanged"
        ></v-checkbox>
    </div>
</template>

<script>
import { ref } from "@vue/composition-api";
import { $t } from "@/i18n";
import AppModule from "@/store/modules/app";

export default {
    name: "CpRightsField",
    props: {
        accountId: {
            type: Number,
            default: 0
        },
        field: {
            type: Object,
            required: true
        },
        value: {
            type: [String, Number, Array],
            default: null
        },
        errorMessages: {
            type: String,
            default: null
        },
        inputCssClass: {
            type: String,
            default: ""
        },
        readonly: {
            type: Number,
            default: 0
        },
        testId: {
            type: String,
            default: ""
        },
        isClientPortalAppEnabled: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: null
        }
    },
    setup(props, ctx) {
        const { rights_masks } = AppModule();

        const formData = ref({
            value: props.value,
            value_error: null
        });

        const accessChanged = ev => {
            formData.value.value_error = null;

            if (ev) {
                formData.value.value = rights_masks.value.client_portal_client_read
            } else {
                formData.value.value = 0
            }

            ctx.emit("change", formData.value.value);
        };

        return {
            formData,
            accessChanged
        };
    }
};
</script>
